/* SUREFIRE YOUTH — sfy-theme.js
   Small, dependency-free enhancements. Everything degrades gracefully:
   - Reveal-on-scroll (skipped for prefers-reduced-motion)
   - Brush Finder tabs (desktop tablist; mobile shows all panels as a scroller)
   - Sticky mobile Add to Cart on product pages (proxies Dawn's product form)
*/
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.sfy-reveal');
    if (!els.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sfy-reveal--in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sfy-reveal--in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Brush Finder tabs (desktop only; CSS handles mobile) ---------- */
  function initFinder() {
    document.querySelectorAll('[data-sfy-finder]').forEach(function (finder) {
      var tabs = Array.prototype.slice.call(finder.querySelectorAll('.sfy-finder__tab'));
      var panels = Array.prototype.slice.call(finder.querySelectorAll('.sfy-finder__panel'));
      if (!tabs.length || !panels.length) return;

      function select(index) {
        tabs.forEach(function (tab, i) {
          var active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          panels[i].classList.toggle('sfy-finder__panel--active', active);
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            e.preventDefault();
            select(next);
            tabs[next].focus();
          }
        });
      });

      select(0);
    });
  }

  /* ---------- Sticky mobile Add to Cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sfy-sticky-atc]');
    if (!bar) return;

    var mainForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    var buyBox = document.querySelector('.product__info-container') || (mainForm && mainForm.closest('section'));
    if (!mainForm || !buyBox) return;

    var btn = bar.querySelector('[data-sfy-sticky-submit]');
    var mainSubmit = mainForm.querySelector('[type="submit"]');

    if (btn) {
      btn.addEventListener('click', function () {
        if (mainSubmit && mainSubmit.getAttribute('aria-disabled') === 'true') return;
        if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
        else mainForm.submit();
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sfy-sticky-atc--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(buyBox);
  }

  function init() {
    initReveal();
    initFinder();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run inside the Theme Editor when sections are re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
